import axiosInstance from '@/utils/api.js'

var state = {
  companies: [],
  currentSupplier: []
}

var getters = {
  COMPANIES: (state) => {
    return state.companies
  },
  CURRENT_SUPPLIER: (state) => {
    return state.currentSupplier
  }
}

var mutations = {
  SET_COMPANIES: (state, payload) => {
    state.companies = payload
  },
  SET_CURRENT_SUPPLIER: (state, payload) => {
    state.currentSupplier = payload
  }
}

var actions = {
  GET_COMPANIES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/suppliers')
    if (result.status === 200) {
      context.commit('SET_COMPANIES', result.data)
    }
  },
  GET_CURRENT_SUPPLIER: async (context, payload) => {
    let result = await axiosInstance.get('/settings/supplier?supplier_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_CURRENT_SUPPLIER', result.data)
    }
  },
  CREATE_COMPANIES: (context, payload) => {
    return axiosInstance.post('/settings/suppliers', payload)
  },
  UPDATE_COMPANIES: (context, payload) => {
    return axiosInstance.put('/settings/suppliers', payload)
  },
  DELETE_COMPANIES: (context, payload) => {
    return axiosInstance.delete('/settings/suppliers?supplier_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/companies.js